const ArrowUp = () => (
  <svg viewBox="0 0 17 16" x="0px" y="0px" width="25">
    <path d="M15.146 8.854l-6.146-6.147v13.293h-1v-13.293l-6.146 6.147-0.708-0.708 7.354-7.353 7.354 7.354-0.708 0.707z" />
  </svg>
);
export default ArrowUp;
